"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (props) {
    return _react2.default.createElement(
        "svg",
        { width: "11", height: "11", viewBox: "0 0 11 11", className: "Icon close-x", xmlns: "http://www.w3.org/2000/svg" },
        _react2.default.createElement("path", { d: "M6.63 5.857l3.89-3.89a.674.674 0 1 0-.954-.955l-3.891 3.89-3.89-3.89a.674.674 0 1 0-.955.955l3.89 3.89-3.89 3.89a.674.674 0 1 0 .954.955l3.891-3.89 3.89 3.89a.674.674 0 1 0 .955-.954l-3.89-3.89z", fill: "#777", fillRule: "evenodd" })
    );
}; /*eslint-disable */


//////////////////
// WEBPACK FOOTER
// ./src/client/components/icons/large/jsx/close-x.js
// module id = 1790
// module chunks = 0